import { Col, Label, SofturaTable, Tooltip, EventHandler } from "client/CommonComponents"
import moment from "moment"
import locationicon from "../../../assets/images/Location_Icon.svg"
import noimage from "../../../assets/images/No_Image_available.svg"

const ActiveAssetAuditHistory = ({
    auditHistoryDetails,
    audithistory_columns,
    audithistory_data,
    handleLocationClick,
    handleImageClick
}: any) => {
    return (
        <>
            <div>
                <div className="activeasset_audithistory">
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="row assetaudithistory_popup">
                            <Col xl={3} lg={4} md={6} className="mb-3">
                                <Tooltip content={auditHistoryDetails?.assetNumber ?? '-'}  data-attribute="ActiveAssetAuditHistory_Default_Tooltip">
                                    <Label data-attribute="ActiveAssetAuditHistory_Default_Label">Asset #</Label>
                                    <p>{auditHistoryDetails?.assetNumber ?? '-'}</p>
                                </Tooltip>
                            </Col>

                            <Col xl={3} lg={4} md={6} className="mb-3 ">
                                <Tooltip content={auditHistoryDetails?.homeCostCenterNo ?? '-'}  data-attribute="ActiveAssetAuditHistory_Default_Tooltip_2">
                                    <Label data-attribute="ActiveAssetAuditHistory_Default_Label_2">Home Cost Center</Label>
                                    <p>{auditHistoryDetails?.homeCostCenterNo ?? '-'}</p>
                                </Tooltip>
                            </Col>

                            <Col xl={3} lg={4} md={6} className="mb-3">
                                <Tooltip content={moment(auditHistoryDetails?.auditOperationDateUTC)?.format("MM/DD/YYYY") ?? '-'} data-attribute="ActiveAssetAuditHistory_Default_Tooltip_3">
                                    <Label data-attribute="ActiveAssetAuditHistory_Default_Label_3">Audit Operation Date</Label>
                                    <p>{moment(auditHistoryDetails?.auditOperationDateUTC)?.format("MM/DD/YYYY") ?? '-'}</p>
                                </Tooltip>
                            </Col>

                            <Col xl={3} lg={4} md={6} className="mb-3">
                                <Tooltip content={(auditHistoryDetails?.latitude != null ? auditHistoryDetails?.latitude : '-') + ' / ' + (auditHistoryDetails?.longitude != null ? auditHistoryDetails?.longitude : '-')} data-attribute="ActiveAssetAuditHistory_Default_Tooltip_4">
                                    <Label data-attribute="ActiveAssetAuditHistory_Default_Label_4">Lattitude / Longitude</Label>
                                    <EventHandler onEvent={() => { handleLocationClick(auditHistoryDetails) }} data-attribute="ActiveAssetAuditHistory_Default_EventHandler">
                                        <p
                                            className="gps_location"
                                        >
                                            {(auditHistoryDetails?.latitude != null ? auditHistoryDetails?.latitude : '-') + ' / ' + (auditHistoryDetails?.longitude != null ? auditHistoryDetails?.longitude : '-')}
                                            <img src={locationicon} alt="location" className="location_icon" />
                                        </p>
                                    </EventHandler>
                                </Tooltip>
                            </Col>

                            <Col xl={3} lg={4} md={6} className="mb-3">
                                <Tooltip content={auditHistoryDetails?.productCode ?? '-'}  data-attribute="ActiveAssetAuditHistory_Default_Tooltip_5">
                                    <Label data-attribute="ActiveAssetAuditHistory_Default_Label_5">Product Code</Label>
                                    <p>{auditHistoryDetails?.productCode ?? '-'}</p>
                                </Tooltip>
                            </Col>

                            <Col xl={3} lg={4} md={6} className="mb-3">
                                <Tooltip content={auditHistoryDetails?.ScannedCostCenterNo ?? '-'}  data-attribute="ActiveAssetAuditHistory_Default_Tooltip_6">
                                    <Label data-attribute="ActiveAssetAuditHistory_Default_Label_6">Scanned Cost Center</Label>
                                    <p>{auditHistoryDetails?.scannedCostCenterNo ?? '-'}</p>
                                </Tooltip>
                            </Col>

                            <Col xl={6} lg={4} md={6} className="mb-3">
                                <Tooltip content={auditHistoryDetails?.auditOperationBy ?? '-'}  data-attribute="ActiveAssetAuditHistory_Default_Tooltip_7">
                                    <Label data-attribute="ActiveAssetAuditHistory_Default_Label_7">Audit Operation By</Label>
                                    <p>{auditHistoryDetails?.auditOperationBy ?? '-'}</p>
                                </Tooltip>
                            </Col>
                        </div>
                    </Col>
                </div>

                <div className="activeasset_audithistory pb-4">
                    <div className="row ImageBlock">
                        <Col xl={3} lg={4} md={6} className="mb-3">
                            <Tooltip data-attribute="ActiveAssetAuditHistory_Default_Tooltip_8">
                                <Label data-attribute="ActiveAssetAuditHistory_Default_Label_8">Asset Image</Label>
                                <div className="assetImageblock">
                                    <EventHandler onEvent={handleImageClick} data-attribute="ActiveAssetAuditHistory_Default_EventHandler_2">
                                        <img src={auditHistoryDetails?.assetImage ?? noimage} alt="asset_image" className="assetImage" />
                                    </EventHandler>
                                </div>
                            </Tooltip>
                        </Col>

                        <Col xl={3} lg={4} md={6} className="mb-3">
                            <Tooltip data-attribute="ActiveAssetAuditHistory_Default_Tooltip_9">
                                <Label data-attribute="ActiveAssetAuditHistory_Default_Label_9">Asset Number Image</Label>
                                <div className="assetImageblock">
                                    <EventHandler onEvent={handleImageClick} data-attribute="ActiveAssetAuditHistory_Default_EventHandler_3">
                                        <img src={auditHistoryDetails?.assetNumberImage ?? noimage} alt="asset_image" className="assetImage" />
                                    </EventHandler>
                                </div>
                            </Tooltip>
                        </Col>

                        <Col xl={3} lg={4} md={6} className="mb-3">
                            <Tooltip data-attribute="ActiveAssetAuditHistory_Default_Tooltip_10">
                                <Label data-attribute="ActiveAssetAuditHistory_Default_Label_10">VIN Serial Number Image</Label>
                                <div className="assetImageblock">
                                    <EventHandler onEvent={handleImageClick} data-attribute="ActiveAssetAuditHistory_Default_EventHandler_4">
                                        <img src={auditHistoryDetails?.vinSerialNumberImage ?? noimage} alt="asset_image" className="assetImage" />
                                    </EventHandler>
                                </div>
                            </Tooltip>
                        </Col>

                        <Col xl={3} lg={4} md={6} className="mb-3">
                            <Tooltip data-attribute="ActiveAssetAuditHistory_Default_Tooltip_11">
                                <Label data-attribute="ActiveAssetAuditHistory_Default_Label_11">Odometer Hour Image</Label>
                                <div className="assetImageblock">
                                    <EventHandler onEvent={handleImageClick} data-attribute="ActiveAssetAuditHistory_Default_EventHandler_5">
                                        <img src={auditHistoryDetails?.odometerHourImage ?? noimage} alt="asset_image" className="assetImage" />
                                    </EventHandler>
                                </div>
                            </Tooltip>
                        </Col>
                    </div>

                    <div className="row assetaudithistory_popup">
                        <Col xl={6} lg={6} md={6} className="exceptions_block">
                            <Label data-attribute="ActiveAssetAuditHistory_Default_Label_12">Exceptions</Label>
                            <div className="exceptions_info_block">{auditHistoryDetails?.exceptions ?? '-'}</div>
                        </Col>

                        <Col xl={6} lg={6} md={6}>
                            <Label data-attribute="ActiveAssetAuditHistory_Default_Label_13">Notes / Data Corrections</Label>
                            <div className="exceptions_info_block">{auditHistoryDetails?.notesDataCorrections ?? '-'}</div>
                        </Col>
                    </div>
                </div>

            </div>

            <div className="audithistory_metricstable pt-2">
                <SofturaTable
                    data={audithistory_data}
                    columns={audithistory_columns}
                    className="custom-class"
                    pagination={false}
                 data-attribute="ActiveAssetAuditHistory_Default_Grid" />
            </div>

        </>
    )
}
export default ActiveAssetAuditHistory
